import { SingleSelect } from "@learningblocks/simulations/shared-components/lib/Questions/SingleSelect";
import React, { useState } from "react";
import { SpectrophotometerSubstanceSSpectrumImage } from "../../SpectrophotometerImages";
import { Utilities } from "@learningblocks/exp-constants";
import cname from "../../style.module.scss";
import { useDispatch } from "react-redux";
import { setChosenWavelengthAction } from "../../store";

const { QUESTION_CONTENTS } = Utilities;

const staticContent = {
  [QUESTION_CONTENTS.QUESTION]: {
    text: "<h3>Which wavelength would you choose to measure the absorbance of substance S?</h3>",
  },
};
export const Content = () => {
  const [options, setOptions] = useState([
    {
      id: 1,
      text: "350 nm",
      disabled: false,
      selected: false,
      value: 350,
      feedback:
        "At 350 nm, the absorbance for substance S is almost 0.3. Is this the highest absorbance reported along the spectrum?",
    },
    {
      id: 2,
      text: "400 nm",
      disabled: false,
      selected: false,
      value: 400,
      feedback:
        "You found the wavelength that is absorbed most by substance S. The spectrophotometer should be set to 400 nm to determine the amount of substance S in the sample.",
    },
    {
      id: 3,
      text: "500 nm",
      disabled: false,
      selected: false,
      value: 500,
      feedback:
        "At 500 nm, the absorbance for substance S is not quite at 0.1. Is this the highest absorbance reported along the spectrum?",
    },
  ]);
  const correctId = 2;
  const [completed, setCompleted] = useState(false);
  const [showFeedback, setShowFeedback] = useState(false);
  const [attempts, setAttempts] = useState(2);
  const dispatch = useDispatch();

  const onSelect = ({ optionID }: { optionID: number }) => {
    setOptions(
      options.map((o) => ({
        ...o,
        selected: o.id === optionID,
      }))
    );
  };
  const onAnswer = () => {
    const currentSelected = options.find((o) => o.selected);
    if (
      (currentSelected && currentSelected.id === correctId) ||
      attempts - 1 === 0
    ) {
      setOptions(options.map((o) => ({ ...o, disabled: true })));
      setCompleted(true);
      dispatch(setChosenWavelengthAction(currentSelected?.value));
      setAttempts(0);
    } else {
      setAttempts(attempts - 1);
      setOptions(options.map((o) => ({ ...o, disabled: o.selected })));
    }
  };
  const content = {
    ...staticContent,
    [QUESTION_CONTENTS.OPTIONS]: options,
  };
  return (
    <div className={cname.content}>
      <div className={cname.content_image_container}>
        <div className={cname.content_image}>
          <SpectrophotometerSubstanceSSpectrumImage />
        </div>
        <div className={cname.caption}>
          Figure 3: The figure shows the absorbance spectrum of substance S
          across a range of wavelengths. Based on this spectrum, which
          wavelength would you choose to measure the absorbance of the sample on
          the spectrophotometer? (Hint: At which wavelength does substance S
          absorb the most light?)
        </div>
      </div>
      <SingleSelect
        complete={completed}
        content={Object.keys(content)}
        answerId={[correctId]}
        totalAttempts={attempts}
        submitAnswer={onAnswer}
        selectOption={onSelect}
        onShowFeedback={() => setShowFeedback(true)}
        showFeedback={showFeedback}
        resetAnswer={() => {}}
        {...content}
      />
    </div>
  );
};
